import * as THREE from 'three';

const directions = [
  new THREE.Vector3(0, -1, 0),  // Abajo
  new THREE.Vector3(0, 1, 0),   // Arriba
  new THREE.Vector3(0, 0, 1),   // Frente
  new THREE.Vector3(0, 0, -1),  // Atrás
  new THREE.Vector3(1, 0, 0),   // Derecha
  new THREE.Vector3(-1, 0, 0)   // Izquierda
];

// Configuraciones ajustables para calibrar la suavidad
const CAMERA_OFFSET = 0.05;      // Distancia mínima ideal al suelo/muros (un poco más grande ayuda a suavizar)
const SMOOTH_FACTOR = 10.0;     // Velocidad de respuesta (A mayor número, más rápido reacciona; a menor número, más suave)

/**
 * Comprueba las colisiones con el terreno y suaviza el movimiento.
 * @param {THREE.Camera} camera - La cámara.
 * @param {THREE.Mesh} terrainMesh - El mesh del terreno.
 * @param {THREE.Raycaster} raycaster - El raycaster.
 * @param {number} deltaTime - El tiempo transcurrido desde el último frame (clock.getDelta()).
 * @returns {boolean} Devuelve true si la cámara se movió.
 */
export function checkTerrainCollision(camera, terrainMesh, raycaster, deltaTime) {
  if (!terrainMesh || terrainMesh.name !== "TERRAIN" || !terrainMesh.geometry) return false;

  // 🔹 NUEVOS AJUSTES ULTRA-CERCANOS
  const CAMERA_OFFSET = 0.01; // Permite que la cámara se acerque muchísimo más (ajusta a 0.005 si aún quieres más abajo)
  const SMOOTH_FACTOR = 25.0; // Subimos la velocidad de respuesta para evitar que traspase el suelo al estar tan cerca
  
  const targetPosition = camera.position.clone();
  let hasCollision = false;

  for (let i = 0; i < directions.length; i++) {
    const dir = directions[i];
    raycaster.set(camera.position, dir);
    const intersects = raycaster.intersectObject(terrainMesh, false);

    if (intersects.length > 0) {
      const distance = intersects[0].distance;

      if (distance < CAMERA_OFFSET) {
        hasCollision = true;
        const penetrationDepth = CAMERA_OFFSET - distance;
        const pushBack = dir.clone().multiplyScalar(-penetrationDepth);
        targetPosition.add(pushBack);

        // Si es el suelo (dirección hacia abajo), la clavamos firmemente a la altura deseada
        if (dir.y === -1) {
          targetPosition.y = intersects[0].point.y + CAMERA_OFFSET;
        }
      }
    }
  }

  if (hasCollision) {
    // Con un SMOOTH_FACTOR alto (25), el LERP reaccionará de golpe si el impacto es fuerte,
    // pero mantendrá una transición limpia sin brincos feos.
    const t = Math.min(SMOOTH_FACTOR * deltaTime, 1.0);
    camera.position.lerp(targetPosition, t);
    return true;
  }

  return false;
}